// extracted by mini-css-extract-plugin
var _1 = "WHJ4r";
var _2 = "cCc1p";
var _3 = "gGbyp";
var _4 = "FV9Pg";
export { _1 as "base", _2 as "main", _3 as "nav", _4 as "search" }
